module.exports = __webpack_public_path__ + "images/6340b16e3a3159c1e7e08dcaea45018b.png";